import { FC } from 'react'

type AddonProps = {
  size: 'default' | 'small' | 'large'
  type?: 'currency' | 'percentage'
  symbol: string
}

export const Addon: FC<AddonProps> = ({ size, symbol, type }) => {
  return (
    <div
      className={`per-input-number__addon per-input-number__addon--${size}` + (type === 'percentage' ? ' bold' : '')}
      style={{ fontSize: symbol.length > 1 ? `${18 - (symbol.length - 1) * 3}px` : undefined }}
    >
      {symbol}
    </div>
  )
}
